import _ from 'underscore';
import { getComponentByTypeFromPageComponents } from './site-config-reader';
import { generateId } from './generate-section-with-component';

const fbAction2ComponentConfig = (action) => {
  const component = {
    type: 'callToAction',
  };

  switch (action.Type) {
    case 'CALL_NOW':
      return _.extend(component, { actionType: 'CallNow', 'data-source-name': 'phoneNumber' });
    case 'EMAIL':
      return _.extend(component, { actionType: 'SendMail', 'data-source-name': 'email' });
    case 'GET_DIRECTIONS':
      return _.extend(component, { actionType: 'GetDirections', 'data-source-name': 'locationInfo' });
    case 'REQUEST_QUOTE':
      return _.extend(component, { actionType: 'GetQuote' });
    case 'CONTACT_US':
      return _.extend(component, { actionType: 'ContactUs' });
    case 'BOOK_APPOINTMENT':
      return _.extend(component, { actionType: 'BookAppointment', linkUrl: action.WebUrl });
    // TODO(Nickyang): Disable following actionTypes as we don't support them now
    // case 'SHOP_NOW':
    //   return _.extend(component, { actionType: 'ShopNow', linkUrl: action.WebUrl });
    // case 'SIGN_UP':
    //   return _.extend(component, { actionType: 'SignUp', linkUrl: action.WebUrl });
    // case 'ORDER_FOOD':
    //   return _.extend(component, { actionType: 'OrderFood', linkUrl: action.WebUrl });
    // case 'PURCHASE_GIFT_CARDS':
    //   return _.extend(component, { actionType: 'PurchaseGiftCard', linkUrl: action.WebUrl });
    default:
      return null;
  }
};

export const fbActions2SmartActionButtons = (fbDataSource) => {
  const actionComponents = _.chain(fbDataSource.callToActions)
    .map(fbAction2ComponentConfig)
    .compact()
    .value();
  return _.filter(actionComponents, cmp => _.has(cmp, 'linkUrl'));
};

export const appendActions2Components = (components, actionCmps) => {
  const callToActionCmp = getComponentByTypeFromPageComponents(components, 'callToAction');

  if (!_.isEmpty(actionCmps) && callToActionCmp !== undefined) {
    _.map(actionCmps, (cmp) => {
      _.extend(cmp, {
        id: generateId('cmp'),
        parentId: callToActionCmp.parentId,
      });
    });
    components.splice(callToActionCmp.index + 1, 0, ...actionCmps);
  }
};
